"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((_a) => {
    var { notice, noticeIndex } = _a, props = __rest(_a, ["notice", "noticeIndex"]);
    const { contents, img_url, regTime } = notice;
    const momentRegTime = (0, moment_1.default)(regTime);
    const isToday = momentRegTime.isSame((0, moment_1.default)(), 'day');
    const regTimeString = () => {
        if (isToday)
            return t('오늘') + momentRegTime.format(' ahh:mm');
        else
            return momentRegTime.format('YYYY.MM.DD ahh:mm');
    };
    const noticeRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: noticeRef }, props, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, alignItems: "center", css: { columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ id: "index_number" }, { children: noticeIndex })), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "reg_time" }, { children: regTimeString() }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "notice_contents" }, { children: (0, html_react_parser_1.default)((0, string_utils_1.newLineCharsToBr)(contents)) })), img_url && (0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(img_url), alt: "" }), (0, jsx_runtime_1.jsx)(components_1.ShowMoreButton, { elementRef: noticeRef, dependency: noticeIndex })] })));
}) `
  padding: 40px 20px 20px;
  margin-bottom: 10px;
  background-color: white;
  overflow: hidden;
  #index_number {
    width: 25px;
    border-radius: 2px;
    background-color: #f8f8f8;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
  }
  #reg_time {
    align-self: center;
    color: rgba(0, 0, 0, 0.5);
  }
  #notice_contents {
    padding-top: 20px;
    font-size: 16px;
    line-height: 25px;
    word-break: break-all;
  }
  img {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 20px;
  }
`;
